type StyleParam = {
  rounded?: boolean;
  bordered?: boolean;
};

export const defaultStyle = ({ rounded, bordered }: StyleParam) => ({
  control: (styles: any, { menuIsOpen }: any) => ({
    ...styles,
    fontSize: 14,
    color: '#9b9b9b',
    boxShadow: 'unset',
    minWidth: 250,
    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: 4,
    ':hover': {
      borderColor: '#cacaca',
      borderBottomColor: menuIsOpen ? '#ffffff' : '#cacaca',
    },
    ...(menuIsOpen
      ? {
          borderBottomColor: '#ffffff',
          // borderBottomLeftRadius: 0,
          // borderBottomRightRadius: 0,
          // borderRadius: rounded ? 22 : 5,
        }
      : {}),
    ...(bordered === true
      ? {
          borderColor: '#cacaca',
          // borderRadius: rounded ? (menuIsOpen ? 20 : 40) : 5,
        }
      : {
          border: 'none',
          borderBottom: '1px solid #cacaca',
          // borderRadius: 0,
        }),
  }),
  valueContainer: (styles: any) => ({
    ...styles,
    padding: rounded === true ? 5 : 0,
  }),
  menu: (styles: any) => ({
    ...styles,
    textAlign: 'left',
    marginTop: 0,
    borderColor: '#cacaca',
    // borderTopLeftRadius: 0,
    // borderTopRightRadius: 0,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderStyle: 'solid',
    boxShadow: 'unset',
    zIndex: 2,
  }),
  menuList: (styles: any) => ({
    ...styles,
    paddingTop: 0,
    textAlign: 'left',
    margin: 0,
  }),
  option: (styles: any, { isSelected, isDisabled }: any) => ({
    ...styles,
    paddingLeft: 14,
    paddingTop: 6,
    paddingBottom: 6,
    color: '#323334',
    fontWeight: 600,
    fontSize: 14,
    opacity: isDisabled ? 0.3 : 1,
    backgroundColor: isSelected ? '#c5d3eb' : '#ffffff',
    ':active': {
      backgroundColor: isSelected ? '#c5d3eb' : '#ffffff',
    },
  }),
});
